import verifiedIcon from '../app/_authenticated/settings/assets/icons/verify_verified_icon.svg';
import verifyProgressIcon from '../app/_authenticated/settings/assets/icons/verify_progress_icon.svg';
import verifyPendingIcon from '../app/_authenticated/settings/assets/icons/verify_pending_icon.svg';

const verificationStates = {
  Verified: 'Verified',
  Pending: 'Pending',
  InProgress: 'InProgress',
  Unverified: 'Unverified',
  Incomplete: 'Incomplete',
}

var verificationCard = {
    title: '',
    subTitle: '',
    icon: verifiedIcon,
    disabled: false,
    subTextClassName: 'text-gray-400',
};

export function getProfileVerificationCard(verificationStatus: string, content: any) {
    if (
        verificationStatus == verificationStates.Unverified || 
        verificationStatus?.includes(verificationStates.Unverified)
    ) {
        verificationCard = {
            title: content.verifyYourAccount,
            subTitle: content.requiredToDepositInvest,
            icon: verifyProgressIcon,
            disabled: false,
            subTextClassName: 'text-[#EEA500]',
        }
    }
    if (
        verificationStatus == verificationStates.InProgress ||
        verificationStatus == verificationStates.Incomplete
    ) {
        verificationCard = {
            title: content.continueVerification,
            subTitle: content.pickupLeftOff,
            icon: verifyProgressIcon,
            disabled: false,
            subTextClassName: 'text-[#EEA500]',
        }
    }
    if (
        verificationStatus == verificationStates.Pending
    ) {
        verificationCard = {
            title: content.verificationSubmitted,
            subTitle: content.reviewingDetails,
            icon: verifyPendingIcon,
            disabled: true,
            subTextClassName: 'text-[#48A7FF]',
        }
    }

    if (
        verificationStatus == verificationStates.Verified
    ) {
        verificationCard = {
            title: content.verified,
            subTitle: '',
            icon: verifiedIcon,
            disabled: true,
            subTextClassName: 'text-gray-400',
        }
    }
    
    return verificationCard;
}